// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import CryptoJS from 'crypto-js';
// import Swal from 'sweetalert2'; // นำเข้า SweetAlert2
// import { formatDate } from '../FormatDate/formatDate';
// import { API_ENDPOINT } from '../auth/config';
// const Credit = ({ data }) => {
//   const [amount, setAmount] = useState(data.value1);
//   const [orderRef, setOrderRef] = useState(data.value2);
//   const [CreatedAt, setCreatedAt] = useState(data.value3);
//   const [idOrder, setidOrder] = useState(data.value4);
//   const [remark, setRemark] = useState('Zoo Ticket');
//   const [securityKey, setSecurityKey] = useState('');
//   const navigate = useNavigate();
//   const merchantId = '900000960';
//   const currCode = '764';
//   const SecureHashKey = localStorage.getItem('credit');
//   // const SecureHashKey = '7nRP3lULxw5BL3c94STU8tHBXsiy9Sw5';
//   const payType = 'N';
//   const lang = 'E';

//   const hasher = () => {
//     const securityKey = `${merchantId}|${orderRef}|${currCode}|${amount}|${payType}|${SecureHashKey}`;
//     const hash = CryptoJS.SHA512(securityKey).toString(CryptoJS.enc.Hex);
//     setSecurityKey(hash);
//     // console.log(hash)
//     // console.log(securityKey)
//   };
//   // useEffect เพื่ออัพเดตสถานะเมื่อ props เปลี่ยนแปลง
//   useEffect(() => {
//     setAmount(data.value1);
//   }, [data.value1]);

//   useEffect(() => {
//     setCreatedAt(data.value3);
//   }, [data.value3]);

//   useEffect(() => {
//     setidOrder(data.value4);
//   }, [data.value4]);

//   useEffect(() => {
//     setOrderRef(data.value2);
//   }, [data.value2]);
//   useEffect(() => {
//     hasher();
//   });

//   const handleCancel = (id) => {
//     // console.log(id)
//     const myHeaders = new Headers();
//     myHeaders.append("Content-Type", "application/json");
//     myHeaders.append("X-API-KEY", localStorage.getItem('apikey'));
//     const raw = JSON.stringify({
//       "order_id": id
//     });

//     const requestOptions = {
//       method: "POST",
//       headers: myHeaders,
//       body: raw,
//       redirect: "follow"
//     };

//     fetch(`${API_ENDPOINT}/api/v1/zoo/e-member/online-order-cancel`, requestOptions)
//       .then(response => response.json())
//       .then(result => {
//         if (result.status === "cancel") {
//           Swal.fire({
//             title: 'ยกเลิกการชำระเงิน',
//             text: 'คุณต้องการยกเลิกการชำระเงินนี้หรือไม่?',
//             icon: 'warning',
//             showCancelButton: true,
//             confirmButtonColor: '#3085d6',
//             cancelButtonColor: '#d33',
//             confirmButtonText: 'ใช่',
//             cancelButtonText: 'ไม่ใช่'
//           }).then((result) => {
//             if (result.isConfirmed) {
//               Swal.fire(
//                 'ยกเลิกแล้ว!',
//                 'รายการของคุณถูกยกเลิกแล้ว',
//                 'success'
//               ).then(() => {
//                 navigate('/OrderList'); // เปลี่ยนเส้นทางไปยังหน้า /OrderList
//               });
//             }
//           });
//         } else {

//         }
//       })
//       .catch((error) => console.error(error));
//   };
//   return (
//     <div className="container mt-3">
//       {/* <p>Value 1: {data.value1}</p>
//       <p>Value 2: {data.value2}</p>
//       <p>Value 3: {data.value3}</p>
//       <p>Value 4: {data.value4}</p> */}
//       <form
//         name="payFormCcard"
//         method="post"
//         action="https://ktbfastpay.ktb.co.th/KTB/eng/payment/payForm.jsp"
//       >

//         <input
//           type="hidden"
//           id="merchantId"
//           name="merchantId"
//           className="form-control"
//           value={merchantId}
//           readOnly
//         />


//         <div className="mb-3 row">
//           {/* <label htmlFor="amount" className="col-sm-3 col-form-label">Amount</label> */}
//           <div className="col-sm-9">
//             <input
//               type="hidden"
//               id="amount"
//               name="amount"
//               className="form-control"
//               value={amount}
//               onChange={(e) => {
//                 setAmount(e.target.value);
//                 hasher();
//               }}
//             />
//           </div>
//         </div>

//         <div className="mb-3 row">
//           {/* <label htmlFor="orderRef" className="col-sm-3 col-form-label">Order Ref</label> */}
//           <div className="col-sm-9">
//             <input
//               type="hidden"
//               id="orderRef"
//               name="orderRef"
//               className="form-control"
//               value={orderRef}
//               onChange={(e) => {
//                 setOrderRef(e.target.value);
//                 hasher();
//               }}
//             />
//           </div>
//         </div>


//         <input
//           type="hidden"
//           id="currCode"
//           name="currCode"
//           className="form-control"
//           value={currCode}
//           readOnly
//         />


//         <div className="mb-3 row">
//           {/* <label htmlFor="remark" className="col-sm-3 col-form-label">Remark</label> */}
//           <div className="col-sm-9">
//             <input
//               type="hidden"
//               id="remark"
//               name="remark"
//               className="form-control"
//               value={remark}
//               onChange={(e) => setRemark(e.target.value)}
//             />
//           </div>
//         </div>

//         <input
//           type="hidden"
//           id="SecureHashKey"
//           name="SecureHashKey"
//           className="form-control"
//           value={SecureHashKey}
//           readOnly
//         />


//         <input
//           type="hidden"
//           id="payType"
//           name="payType"
//           className="form-control"
//           value={payType}
//           readOnly
//         />



//         <input
//           type="hidden"
//           id="lang"
//           name="lang"
//           className="form-control"
//           value={lang}
//           readOnly
//         />


//         <input type="hidden" name="successUrl" value={`${API_ENDPOINT}/emember/creditv1/ktb/web/payment-success.php?order_id=${orderRef}&amount=${amount}`} />
//         <input type="hidden" name="failUrl" value={`${API_ENDPOINT}/emember/creditv1/ktb/web/payment-fail.php?order_id=${orderRef}&amount=expired`} />
//         <input type="hidden" name="cancelUrl" value={`${API_ENDPOINT}/emember/creditv1/ktb/web/payment-cancel.php?order_id=${orderRef}`} />
//         <input type="hidden" name="securityKey" id="securityKey" value={securityKey} />
//         <input type="hidden" name="chanel" id="chanel" value="web" />
//         {/* <button type="submit" class="btn btn-success btn-block">ชำระเงิน</button> */}
//         {/* <button type="submit" className="btn btn-primary">Submit</button> */}


//         <div className="text-center card">
//           <div className="row">
//             <div className=" col-xs-10 col-sm-10 col-md-12 col-xs-offset-1 col-sm-offset-1 col-md-offset-3">
//               <div className="row">
//                 <div className="col-xs-6 col-sm-6 col-md-12">
//                   <address>
//                     <strong>ID: {orderRef} </strong>
//                     <br />
//                     ZOO E-TICKET


//                   </address>
//                 </div>
//                 <div className="col-xs-6 col-sm-6 col-md-12 ">
//                   <p>
//                     <em>Date: {formatDate(CreatedAt)}</em>
//                   </p>

//                 </div>
//               </div>
//               <div className="row">

//                 <table className="table table-hover text-center">
//                   <thead>

//                   </thead>
//                   <tbody className='text-center'>
//                     <tr>

//                       <td className="col-md-12 text-center">ยอด {amount} บาท</td>
//                       <td className="col-md-1 text-center"></td>

//                     </tr>
//                     <tr>

//                       <td className="col-md-1 text-center">เลข orderref {orderRef}</td>
//                       <td className="col-md-1 text-center"></td>

//                     </tr>
//                     <tr>

//                       <td className="col-md-1 text-center">Order on website </td>
//                       <td className="col-md-1 text-center"></td>

//                     </tr>

//                     {/* <tr>
           
//                   <td> </td>
//                   <td className="text-right">
//                     <h4>
//                       <strong>Total:</strong>
//                     </h4>
//                   </td>
//                   <td className="text-center text-danger">
//                     <h4>
//                       <strong>${amount}</strong>
//                     </h4>
//                   </td>
//                 </tr> */}
//                   </tbody>
//                 </table>

//               </div>
//             </div>
//           </div>
//           <button type="submit" className="btn btn-success  btn-block mt-3">
//             Pay Now <span className="glyphicon glyphicon-chevron-right"></span>
//           </button>
//           <button
//             type="button"
//             className="btn btn-danger  btn-block mt-2"
//             onClick={() => handleCancel(idOrder)}
//           >
//             Cancel <span className="glyphicon glyphicon-remove"></span>
//           </button>
//         </div>

//       </form>
//     </div>
//   );
// }

// export default Credit;





import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import { formatDate } from '../FormatDate/formatDate';
import { API_ENDPOINT } from '../auth/config';

/* ─────────── STYLES ─────────── */
const css = `
  @import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;500;600;700&family=DM+Serif+Display:ital@0;1&display=swap');

  :root {
    --bg:        #070d1a;
    --surface:   #0f1c32;
    --surface2:  #152238;
    --border:    rgba(255,255,255,0.07);
    --blue:      #3b82f6;
    --blue-dim:  rgba(59,130,246,0.12);
    --blue-glow: rgba(59,130,246,0.35);
    --red:       #ef4444;
    --green:     #22c55e;
    --text:      #f1f5f9;
    --muted:     #64748b;
    --font:      'Sarabun', sans-serif;
  }

  .cr-wrap {
    color: var(--text);
    max-width: 480px;
    margin: 0 auto;
    padding: 0 4px;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  /* ── INVOICE CARD ── */
  .cr-invoice {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 20px;
    overflow: hidden;
  }

  .cr-invoice-header {
    padding: 18px 22px 14px;
    border-bottom: 1px solid var(--border);
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }

  .cr-invoice-eyebrow {
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: var(--blue);
    margin-bottom: 4px;
    display: flex; align-items: center; gap: 6px;
  }

  .cr-invoice-id {

    font-size: 1.15rem;
    color: var(--text);
    letter-spacing: 0.01em;
  }

  .cr-invoice-badge {
    background: var(--blue-dim);
    border: 1px solid rgba(59,130,246,0.2);
    border-radius: 8px;
    padding: 6px 12px;
    font-size: 0.72rem;
    font-weight: 600;
    color: #93c5fd;
    white-space: nowrap;
    text-align: center;
  }

  .cr-invoice-badge span {
    display: block;
    font-size: 0.65rem;
    color: var(--muted);
    font-weight: 400;
    margin-bottom: 2px;
  }

  /* ── AMOUNT ROW ── */
  .cr-amount-row {
    padding: 18px 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(135deg, rgba(59,130,246,0.07) 0%, rgba(59,130,246,0.02) 100%);
    border-bottom: 1px solid var(--border);
  }

  .cr-amount-label {
    font-size: 0.78rem;
    color: var(--muted);
    margin-bottom: 4px;
    font-weight: 500;
  }

  .cr-amount-value {
    font-size: 2rem;
    color: var(--text);
    letter-spacing: -0.02em;
    line-height: 1;
  }

  .cr-amount-value sup {
    font-size: 0.9rem;
    color: var(--muted);
    vertical-align: super;
    margin-right: 4px;
    font-weight: 400;
  }

  .cr-amount-value sub {
    font-size: 0.85rem;
    color: var(--muted);
    margin-left: 6px;
    font-weight: 400;
    vertical-align: baseline;
  }

  .cr-visa-logos {
    display: flex;
    gap: 4px;
    align-items: center;
    opacity: 0.7;
  }

  .cr-visa-logos img {
    height: 22px;
    object-fit: contain;
    filter: brightness(1.4) saturate(0.6);
  }

  /* ── DETAIL ROWS ── */
  .cr-details {
    padding: 14px 22px 18px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .cr-detail-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.84rem;
  }

  .cr-detail-key   { color: var(--muted); font-weight: 500; }
  .cr-detail-value { color: #cbd5e1; font-weight: 600; font-size: 0.84rem; }

  .cr-divider {
    height: 1px;
    background: var(--border);
    margin: 4px 0;
  }

  /* ── SECURE NOTICE ── */
  .cr-secure {
    margin: 0 22px 16px;
    padding: 10px 14px;
    background: rgba(34,197,94,0.06);
    border: 1px solid rgba(34,197,94,0.15);
    border-radius: 10px;
    display: flex; gap: 10px; align-items: center;
    font-size: 0.75rem; color: #86efac; line-height: 1.5;
  }

  .cr-secure-icon { font-size: 1rem; flex-shrink: 0; }

  /* ── BUTTONS ── */
  .cr-btn-row {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .cr-btn-pay {
    width: 100%;
    padding: 16px;
    background: linear-gradient(135deg, #3b82f6, #2563eb);
    border: none;
    border-radius: 14px;
    color: #fff;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.15s, box-shadow 0.15s;
    box-shadow: 0 4px 20px var(--blue-glow);
    display: flex; align-items: center; justify-content: center; gap: 10px;
    position: relative;
    overflow: hidden;
  }

  .cr-btn-pay::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(255,255,255,0.12) 0%, transparent 60%);
    pointer-events: none;
  }

  .cr-btn-pay:hover { transform: translateY(-2px); box-shadow: 0 8px 32px rgba(59,130,246,0.5); }
  .cr-btn-pay:active { transform: translateY(0); }

  .cr-btn-pay svg { width: 18px; height: 18px; }

  .cr-btn-cancel {
    width: 100%;
    padding: 13px;
    background: transparent;
    border: 1.5px solid rgba(239,68,68,0.28);
    border-radius: 14px;
    color: #fca5a5;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;
    display: flex; align-items: center; justify-content: center; gap: 8px;
  }

  .cr-btn-cancel:hover { background: rgba(239,68,68,0.08); border-color: rgba(239,68,68,0.5); }

  /* ── MOBILE ── */
  @media (max-width: 480px) {
    .cr-wrap { padding: 0; gap: 12px; }
    .cr-invoice-header { padding: 14px 16px 12px; flex-direction: column; }
    .cr-amount-row { padding: 14px 16px; flex-wrap: wrap; gap: 12px; }
    .cr-amount-value { font-size: 1.6rem; }
    .cr-details { padding: 12px 16px 14px; }
    .cr-secure { margin: 0 16px 14px; }
  }
`;

/* ── ICONS ── */
const CardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
    <line x1="1" y1="10" x2="23" y2="10"/>
  </svg>
);
const XIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

/* ─────────── COMPONENT ─────────── */
const Credit = ({ data }) => {
  const [amount,    setAmount]    = useState(data.value1);
  const [orderRef,  setOrderRef]  = useState(data.value2);
  const [createdAt, setCreatedAt] = useState(data.value3);
  const [idOrder,   setIdOrder]   = useState(data.value4);
  const [remark]                  = useState('Zoo Ticket');
  const [securityKey, setSecurityKey] = useState('');
  const navigate = useNavigate();

  const merchantId    = '900000960';
  const currCode      = '764';
  const SecureHashKey = localStorage.getItem('credit');
  const payType       = 'N';
  const lang          = 'E';

  /* ── Hashing ── */
  const hasher = () => {
    const key  = `${merchantId}|${orderRef}|${currCode}|${amount}|${payType}|${SecureHashKey}`;
    const hash = CryptoJS.SHA512(key).toString(CryptoJS.enc.Hex);
    setSecurityKey(hash);
  };

  useEffect(() => { setAmount(data.value1);   }, [data.value1]);
  useEffect(() => { setOrderRef(data.value2);  }, [data.value2]);
  useEffect(() => { setCreatedAt(data.value3); }, [data.value3]);
  useEffect(() => { setIdOrder(data.value4);   }, [data.value4]);
  useEffect(() => { hasher(); });

  /* ── Cancel ── */
  const handleCancel = (id) => {
    const opts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-API-KEY': localStorage.getItem('apikey') },
      body: JSON.stringify({ order_id: id }),
      redirect: 'follow',
    };

    fetch(`${API_ENDPOINT}/api/v1/zoo/e-member/online-order-cancel`, opts)
      .then(r => r.json())
      .then(result => {
        if (result.status !== 'cancel') return;
        Swal.fire({
          title: 'ยืนยันการยกเลิก', text: 'ต้องการยกเลิกการชำระเงินนี้หรือไม่?',
          icon: 'warning', showCancelButton: true,
          confirmButtonColor: '#22c55e', cancelButtonColor: '#ef4444',
          confirmButtonText: 'ใช่, ยกเลิก', cancelButtonText: 'ไม่, กลับไป',
          background: '#0f1c32', color: '#f1f5f9',
        }).then(r => { if (r.isConfirmed) navigate('/OrderList'); });
      })
      .catch(console.error);
  };

  /* ── RENDER ── */
  return (
    <>
      <style>{css}</style>
      <div className="cr-wrap mt-5">
        <form
          name="payFormCcard"
          method="post"
          action="https://ktbfastpay.ktb.co.th/KTB/eng/payment/payForm.jsp"
        >
          {/* hidden fields */}
          <input type="hidden" name="merchantId"    value={merchantId} />
          <input type="hidden" name="amount"        value={amount} />
          <input type="hidden" name="orderRef"      value={orderRef} />
          <input type="hidden" name="currCode"      value={currCode} />
          <input type="hidden" name="remark"        value={remark} />
          <input type="hidden" name="SecureHashKey" value={SecureHashKey} />
          <input type="hidden" name="payType"       value={payType} />
          <input type="hidden" name="lang"          value={lang} />
          <input type="hidden" name="securityKey"   value={securityKey} />
          <input type="hidden" name="chanel"        value="web" />
          <input type="hidden" name="successUrl"    value={`${API_ENDPOINT}/emember/creditv1/ktb/web/payment-success.php?order_id=${orderRef}&amount=${amount}`} />
          <input type="hidden" name="failUrl"       value={`${API_ENDPOINT}/emember/creditv1/ktb/web/payment-fail.php?order_id=${orderRef}&amount=expired`} />
          <input type="hidden" name="cancelUrl"     value={`${API_ENDPOINT}/emember/creditv1/ktb/web/payment-cancel.php?order_id=${orderRef}`} />

          {/* INVOICE CARD */}
          <div className="cr-invoice">

            {/* Header */}
            <div className="cr-invoice-header">
              <div>
                <div className="cr-invoice-eyebrow">
                  💳 Zoo E-Ticket — KTB FastPay
                </div>
                <div className="cr-invoice-id">#{orderRef}</div>
              </div>
              <div className="cr-invoice-badge">
                <span>วันที่ออกบิล</span>
                {createdAt ? formatDate(createdAt) : '—'}
              </div>
            </div>

            {/* Amount */}
            <div className="cr-amount-row">
              <div>
                <div className="cr-amount-label">ยอดชำระทั้งหมด</div>
                <div className="cr-amount-value">
                  <sup>฿</sup>
                  {Number(amount).toLocaleString()}
                  <sub>บาท</sub>
                </div>
              </div>
              <div className="cr-visa-logos">
                <img src="https://i.imgur.com/sB4jftM.png" alt="Visa/MC/JCB" />
              </div>
            </div>

            {/* Details */}
            <div className="cr-details">
              <div className="cr-detail-row">
                <span className="cr-detail-key">ประเภทรายการ</span>
                <span className="cr-detail-value">Zoo E-Ticket</span>
              </div>
              <div className="cr-divider" />
              <div className="cr-detail-row">
                <span className="cr-detail-key">Order Reference</span>
                <span className="cr-detail-value" style={{ fontFamily: 'monospace', letterSpacing: '0.04em' }}>
                  {orderRef}
                </span>
              </div>
              <div className="cr-detail-row">
                <span className="cr-detail-key">ช่องทางชำระ</span>
                <span className="cr-detail-value">บัตรเครดิต / เดบิต</span>
              </div>
              <div className="cr-detail-row">
                <span className="cr-detail-key">ธนาคาร</span>
                <span className="cr-detail-value">KTB FastPay</span>
              </div>
            </div>

            {/* Secure Notice */}
            {/* <div className="cr-secure">
              <span className="cr-secure-icon">🔒</span>
              <span>การชำระเงินนี้เข้ารหัสด้วย SHA-512 และส่งผ่านระบบที่ปลอดภัยของ KTB Bank</span>
            </div> */}
          </div>

          {/* ACTION BUTTONS */}
          <div className="cr-btn-row mt-3">
            <button type="submit" className="cr-btn-pay">
              <CardIcon />
              ชำระเงิน ฿{Number(amount).toLocaleString()} บาท
            </button>
            <button
              type="button"
              className="cr-btn-cancel"
              onClick={() => handleCancel(idOrder)}
            >
              <XIcon /> ยกเลิกรายการนี้
            </button>
          </div>

        </form>
      </div>
    </>
  );
};

export default Credit;